import { HttpInterceptorFn } from '@angular/common/http';

const WHITE_LIST = [
  'assets',
  'googleapis.com',
  'accounts.google.com',
  'oauth2.googleapis.com',
  'openidconnect.googleapis.com'
];

export const contentTypeInterceptor: HttpInterceptorFn = (req, next) => {
  const whiteListed = new RegExp(WHITE_LIST.join('|')).test(req.url);

  if (whiteListed) {
    return next(req);
  }

  const allowedFormDataMethods = ['POST', 'PUT', 'PATCH'];

  if (
    allowedFormDataMethods.includes(req.method) &&
    req.body instanceof FormData
  ) {
    const request = req.clone({
      headers: req.headers.delete('Content-Type')
    });

    return next(request);
  }

  const request = req.clone({
    setHeaders: {
      'Content-Type': 'application/json'
    }
  });

  return next(request);
};
